import { useNavigate } from 'react-router-dom';
import MyCollectRender from '@/sub-luca-plugin/components/my-collect-render';
import { PageBackIcon } from '@/sub-luca-plugin/compatible-components/svg-icons';
import './index.scss';

const MyCollect = (props: any) => {
    const navigate = useNavigate();

    return (
        <div className="my-collect-container">
            <div className="my-collect">
                <div className="my-collect-title">
                    <PageBackIcon onClick={() => navigate(-1)} />
                    <span>我的收藏</span>
                </div>
                <div className="my-collect-card">
                    <MyCollectRender {...props} pageSize={24} />
                </div>
            </div>
        </div>
    );
};

export default MyCollect;
